module.exports = __webpack_public_path__ + "img/dark-header-2.4bd17a11.png";